/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CcmAccountStatusEnum } from './ccmAccountStatusEnum';
import { CloudCostMgmtDetailedSummary } from './cloudCostMgmtDetailedSummary';
import { CloudCostMgmtCostTrend } from './cloudCostMgmtCostTrend';
import { CcmAccountOnboardedByEnum } from './ccmAccountOnboardedByEnum';
import { CloudCostMgmtCostByService } from './cloudCostMgmtCostByService';
import { CloudCostMgmtServiceInfo } from './cloudCostMgmtServiceInfo';


/**
 * Detailed account information with services and cost analysis
 */
export interface CloudCostMgmtDetailedAccountResponse { 
    /**
     * AWS Account ID
     */
    account_id: string;
    /**
     * Organization name
     */
    org_name?: string;
    /**
     * Organization ID (UUID)
     */
    org_id?: string;
    status: CcmAccountStatusEnum;
    onboarded_by?: CcmAccountOnboardedByEnum;
    /**
     * Whether cleanup is enabled
     */
    cleanup_enabled?: boolean;
    /**
     * Last scan timestamp
     */
    last_scan?: Date;
    summary?: CloudCostMgmtDetailedSummary;
    /**
     * List of services with cost and resource information
     */
    services?: Array<CloudCostMgmtServiceInfo>;
    /**
     * Historical cost trend (last 6 months)
     */
    cost_trend?: Array<CloudCostMgmtCostTrend>;
    /**
     * Cost breakdown by service with percentages
     */
    cost_by_service?: Array<CloudCostMgmtCostByService>;
}
export namespace CloudCostMgmtDetailedAccountResponse {
}


